const initState = {
    // number of axios requests currently in flight
    count: 0,
}

export default (state = initState, action) => {
    switch (action.type) {
        case 'requestStart':
            return {
                ...state, count: state.count + 1
            };
        case 'requestEnd':
            return {
                ...state, count: Math.max(0, state.count - 1)
            };
        default:
            return {...state}
    }
}
